import * as React from 'react';

import { Alert, Image2, Link } from '../';
import _ from '../../locale';
import { styled } from '../../theme';
import renderErrors from '../../utility/renderErrors';
import SignInForm from './SignInForm';

const Container = styled('div')({
    maxWidth: 400,
    margin: '0 auto',
});

const Logo = styled('div')({
    margin: '0 auto',
    paddingTop: 40,
    paddingBottom: 40,
});

const StyledAlert = styled(Alert)({
    marginBottom: 20,
});

const LinksContainer = styled('div')({
    borderTop: '1px solid #e5e5e5',
    marginTop: 25,
    paddingTop: 25,
    textAlign: 'center',
});

type Props = {
    signIn: (email: string, password: string) => void;
    onSuccess: (response: object) => void;
    onForgotPassword: (email?: string) => void;
    onRegisterClick?: () => void;
    onSignInWithSSO: () => void;
    errors?: any;
    successMessages?: any;
    resendPath?: string;
};

const SignIn: React.FC<Props> = ({
    onForgotPassword,
    onRegisterClick,
    onSignInWithSSO,
    signIn,
    onSuccess,
    errors,
    successMessages,
    resendPath,
}) => (
    <Container>
        <Logo>
            <Image2 src="/img/logo-ihme.png" />
        </Logo>

        {errors && <StyledAlert color="error">{renderErrors(errors)}</StyledAlert>}

        {successMessages && (
            <StyledAlert color="success">{renderErrors(successMessages)}</StyledAlert>
        )}

        <SignInForm signIn={signIn} onSuccess={onSuccess} resendPath={resendPath} />
        <LinksContainer>
            {onRegisterClick && (
                <>
                    <Link onClick={onRegisterClick}>{_('sign_in_scene_register_link')}</Link>
                    <br />
                    <br />
                </>
            )}
            <Link onClick={onForgotPassword}>{_('sign_in_scene_forgot_password_link')}</Link>
        </LinksContainer>
        {onSignInWithSSO && (
            <LinksContainer>
                <Link onClick={onSignInWithSSO}>{_('sign_in_scene_sign_in_with_sso_button')}</Link>
            </LinksContainer>
        )}
    </Container>
);

export default SignIn;
